var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlineEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.62 18.04L30.46 19.88L12.34 38H10.5V36.16L28.62 18.04ZM35.82 6C35.32 6 34.8 6.2 34.42 6.58L30.76 10.24L38.26 17.74L41.92 14.08C42.1054 13.895 42.2525 13.6752 42.3529 13.4332C42.4532 13.1913 42.5049 12.9319 42.5049 12.67C42.5049 12.4081 42.4532 12.1487 42.3529 11.9068C42.2525 11.6648 42.1054 11.445 41.92 11.26L37.24 6.58C36.84 6.18 36.34 6 35.82 6ZM28.62 12.38L6.5 34.5V42H14L36.12 19.88L28.62 12.38Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineEdit);
export default __webpack_public_path__ + "static/media/ic_outline-edit.c5c026ca8d0547b33f6bb9bf43cc9098.svg";
export { ForwardRef as ReactComponent };